import PropTypes from 'prop-types';

const filterWidgetPropTypes = {
  dispatch: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    categories: PropTypes.arrayOf(PropTypes.any),
    sections: PropTypes.arrayOf(PropTypes.any),
    brands: PropTypes.arrayOf(PropTypes.any)
  }),
  values: PropTypes.shape({
    category: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    section: PropTypes.string,
    brand: PropTypes.string,
    discount: PropTypes.string,
    highRating: PropTypes.bool,
    minPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    maxPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    sort: PropTypes.string
  }),

  isModal: PropTypes.bool,
  show: PropTypes.bool,
  onClose: PropTypes.func,

  showRating: PropTypes.bool,
  setFieldValue: PropTypes.func,
  onFilterSubmit: PropTypes.func,
  onFilterChange: PropTypes.func,
  onCategoryChange: PropTypes.func,
  showRecommendations: PropTypes.bool,
  recommendedCategories: PropTypes.arrayOf(PropTypes.object),
  selectedCategory: PropTypes.shape({
    id: PropTypes.number
  }),
  getHelpers: PropTypes.func,
  onCleanFilters: PropTypes.func,
  firstCategory: PropTypes.number,
  setFirstCategory: PropTypes.func,
  priceFilterCanBeSent: PropTypes.func
};

export default filterWidgetPropTypes;
